import { NgClass } from '@angular/common'
import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import {
  ComponentShape,
  ComponentSize,
  ThemeColors,
} from '@wm-front/shared/enums'

@Component({
  selector: 'wm-front-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class BadgeComponent {
  /** The color of the badge according to the theme */
  @Input() public status: ThemeColors | 'transparent' | 'white'

  /** The raised or flat condition of the badge */
  @Input() public flat?: boolean

  /** Whether or not it is outline */
  @Input() public outline?: boolean

  /** The size of the badge */
  @Input() public size?: ComponentSize = ComponentSize.MEDIUM

  /** The shape of the badge */
  @Input() public shape: ComponentShape = ComponentShape.SEMI_ROUND
}
